import { Kbd } from '@/components/ui/kbd';

import { type PageDrillDown } from '../types';
import { isDrillableValue } from '../utils';

type TabHintProps = {
  value: string;
  highlightedValue?: string;
  pageDrillDown: PageDrillDown | null;
};

export const TabHint = ({ value, highlightedValue, pageDrillDown }: TabHintProps) =>
  highlightedValue === value && isDrillableValue(value, pageDrillDown) ? <Kbd>Tab</Kbd> : null;
